import type { ReactElement } from "react";

export default function NoResult(): ReactElement {
  return (
    <>
      <div className="w-full">
        <p className="text-xl">
          Sorry, no information was found that matches your search.
        </p>
      </div>
    </>
  );
}
